export default __webpack_public_path__ + "static/media/forbidden-users.9f02a7c1.svg";